<template><div>

    <Modal v-model="isModalShown"
        title=""
        wrapper-class="animate__animated"
        modal-class="room-modal"
        in-class="animate__zoomIn hideScroll"
        out-class="animate__zoomOut hideScroll">
        <div class="room-modal__header room-modal-header">
            <ModalTitle class="room-modal-header__title" @close="isModalShown = false">
                {{ props.title }}
            </ModalTitle>
        </div>
        <div class="discount-modal">
            <div class="discount-modal__content">
                <div class="discount-modal__html">
                    <template v-if="!props.discountob.useList">
                        <InsertHtml class="html" :html="props.discountob.text" link="pdf" />
                    </template>
                    <div v-else>
                        <div v-for="({name}) in props.discountob.list">{{name}}</div>
                    </div>
                </div>
            </div>
            <div v-if="props.discountob.useList">
                <DiscountVdh />
            </div>
        </div>

    </Modal>


    <div class="discount">
        <div class="discount__header">
            <div class="discount__title">{{ props.title }}</div>
            <div class="discount__badge" :class="{[props.iconClass]: props.iconClass}">
                <component 
                :is="icon_comp(props.icon)" 
                class="discount__badge-icon"
                />
            </div>
        </div>
        <div class="discount__content">
            <div class="discount__html">
                <template v-if="!props.discountob.useList">
                    <InsertHtml class="discount__hide" :html="props.discountob.text" link="pdf" />
                </template>
                <div v-else>
                    <div v-for="({name}) in props.discountob.list">{{name}}</div>
                </div>
            </div>
        </div>
        <a class="discount__link discount__open" @click.stop.prevent="detail_click">Подробная информация о скидках</a>
    </div>


</div></template>

<style lang="scss" src="./Discount.scss"></style>

<script setup>
import {ref, onMounted, computed } from 'vue'
import DefaultIcon from '@/assets/vicons/seal-percent.vue'
import vRemove from '@/assets/vicons/remove.vue'

import  Modal  from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'
import 'animate.css'

import DiscountVdh from '@/comp/DiscountVdh/DiscountVdh.vue'
import ModalTitle from '@/comp/ModalTitle/ModalTitle.vue'
import InsertHtml from '@/comp/IncludedBlock/InsertHtml.vue'


const isModalShown=ref(false)
const opened  = ref(false)

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
  },
  iconClass: {
    type: String,
    default: null
  },
  included: {
    type: String,
  },
  discountob: Object, 
  show: Boolean
})


const detail_click = () => {
    isModalShown.value = true
}


const icon_comp = () => {
    return DefaultIcon
}

const toggle = () => {
    opened.value = !opened.value
}

onMounted( () => {
    opened.value = props.show ? true : false
} )

    
</script>


